<script setup lang="ts">
import { Plus, Minus, LocateFixed } from "@lucide/vue";
import { Button } from "@/components/ui/button";

defineProps<{
  locateTitle?: string;
}>();

const emit = defineEmits<{
  "zoom-in": [];
  "zoom-out": [];
  locate: [];
}>();
</script>

<template>
  <div
    class="flex flex-col items-center gap-0 rounded-control border border-app-border bg-app-material p-1.5"
  >
    <Button
      variant="control"
      size="icon"
      radius="small"
      aria-label="Zoom in"
      @click="emit('zoom-in')"
    >
      <Plus class="h-5 w-5" />
    </Button>
    <div class="h-px w-7 bg-app-selected" />
    <Button
      variant="control"
      size="icon"
      radius="small"
      aria-label="Zoom out"
      @click="emit('zoom-out')"
    >
      <Minus class="h-5 w-5" />
    </Button>
    <div class="h-px w-7 bg-app-selected" />
    <Button
      variant="control"
      size="icon"
      radius="small"
      @click="emit('locate')"
      :title="locateTitle"
    >
      <LocateFixed class="h-5 w-5" />
    </Button>
  </div>
</template>
